module.exports = __webpack_public_path__ + "static/img/1.6ec65d8f.png";